module.exports = __webpack_public_path__ + "img/icon_camera_logo_n.c0593238.png";